import { render, staticRenderFns } from "./AppHotKeyword.vue?vue&type=template&id=bc545ad0&scoped=true&"
import script from "./AppHotKeyword.vue?vue&type=script&lang=js&"
export * from "./AppHotKeyword.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./AppHotKeyword.vue?vue&type=style&index=0&id=bc545ad0&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "bc545ad0",
  null
  ,true
)

export default component.exports